import router from '@/router'
import axios from '@/plugins/axios'

const moduleUser = {
	namespaced: true,
	state: {
		NICK_NAME: '' || localStorage.getItem('nickname'), // 用户昵称
		LOGIN_TYPE: '' || localStorage.getItem('login_type') || 'yostar', // 登入平台
		NAME_CHILD: true, // 玩家起名
	},
	mutations: {
		SET_NICK_NAME: (state, params) => {
			state.NICK_NAME = params
			localStorage.setItem('nickname', params)
		},
		REMOVE_NICK_NAME: state => {
			state.NICK_NAME = ''
			localStorage.removeItem('nickname')
		},
		SET_LOGIN_TYPE: (state, params) => {
			state.LOGIN_TYPE = params
			localStorage.setItem('login_type', params)
		},
		REMOVE_LOGIN_TYPE: state => {
			state.LOGIN_TYPE = ''
			localStorage.removeItem('login_type')
		},
		SET_NAME_CHILD: (state, params) => {
			state.NAME_CHILD = params
		},
	},
	actions: {
		getUserInfo({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.get('/auth/getuserinfo')
					.then(v => {
						if (v.retcode == 2000) {
							commit('SET_NICK_NAME', v.data.nickname)
							commit('SET_NAME_CHILD', true)
						} else if (v.retcode == 3001) {
							// console.log('1111')
							// //      没查到用户昵称信息， 用户首次登入，或登入后未取昵称
							// if (router.currentRoute.name !== "/") {
							//     router.replace({
							//         path: '/',
							//         query: {
							//             redirect: router.currentRoute.fullPath,
							//             nickname: true
							//         }    // 将跳转的路由path作为参数，登录成功后跳转到该路由
							//     })
							// } else {
							//     router.replace({
							//         path: '/',
							//         query: {
							//             nickname: true
							//         }    // 将跳转的路由path作为参数，登录成功后跳转到该路由
							//     })
							// }
							commit('SET_NAME_CHILD', false)
						}
						resolve(v)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		logout({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.get('/auth/logout')
					.then(v => {
						if (v.retcode == 2000) {
							commit('REMOVE_NICK_NAME')
							commit('REMOVE_LOGIN_TYPE')
						}
						resolve(v)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
	},
	getters: {},
}

export default moduleUser
